if (!customElements.get('cart-drawer-info-slider')) {
  class CartDrawerInfoSlider extends HTMLElement {
    constructor() {
      super();

      if (Shopify.designMode) {
        window.addEventListener('shopify:section:load', () => {
          this.init();
        });
      }
      this.init();
    }

    init() {
      var swiperArea = document.querySelector('.cart-drawer__swiper');
      if (!swiperArea || !window.Swiper) return;

      // 슬라이드가 하나뿐이면 순환도 자동 넘김도 할 일이 없다.
      // 켜두면 Swiper 가 경고를 남기고, 넘어가지도 못하는 타이머만 돈다.
      // 나중에 슬라이드가 늘면 여기서 자동으로 다시 켜진다.
      var multiple = swiperArea.querySelectorAll('.swiper-slide').length > 1;

      this.slider = new Swiper(swiperArea, {
        direction: 'vertical',
        slidesPerView: 1,
        loop: multiple,
        allowTouchMove: false,
        autoplay: multiple ? { delay: 5000 } : false
      });
    }
  }

  (function () {
    window.__fsTextPainterInstalled = true;
    window.__fsTextPainterInstalled_v2 = true;
    window.__freeShippingFxPainterInstalled = true;

    if (window.__sgFreeLimitAttrOnlyPainterInstalled) return;
    window.__sgFreeLimitAttrOnlyPainterInstalled = true;

    function up(v) { return v ? String(v).trim().toUpperCase() : ""; }

    var SUPPORTED_COUNTRIES = {
      US: 1, CA: 1, AU: 1, CH: 1, NZ: 1,
      DE: 1, FR: 1, IE: 1, BE: 1,
      NO: 1, GB: 1, SG: 1, CL: 1, SE: 1,
      SA: 1, AE: 1, KR: 1, PH: 1, HK: 1, JP: 1
    };

    var US_DEFAULT_ISO = "USD";
    var US_DEFAULT_LIMIT = 69;

    function getCountry() {
      var b = document.body;

      var cc = up(b.getAttribute("data-country"));
      if (cc) return cc.slice(0, 2);

      cc = up(b.getAttribute("data-crc-country"));
      if (cc) return cc.slice(0, 2);

      var sc = window.Shopify && window.Shopify.country;
      cc = up(sc);
      if (cc) return cc.slice(0, 2);

      var lang = document.documentElement.getAttribute("lang") || (window.Shopify && window.Shopify.locale) || "";
      var m = String(lang).match(/-([A-Za-z]{2})$/);
      if (m && m[1]) return up(m[1]).slice(0, 2);

      return "";
    }

    function getIso() {
      var b = document.body;
      var iso = up(b.getAttribute("data-crciso"));
      if (iso) return iso;

      iso = up(b.getAttribute("data-currency"));
      if (iso) return iso;

      var sc = window.Shopify && window.Shopify.currency;
      if (typeof sc === "string") return up(sc);
      if (sc && typeof sc === "object") return up(sc.active || sc.iso_code || sc.code || sc.currency || "");

      var metaIso = window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.currency;
      iso = up(metaIso);
      return iso || "USD";
    }

    function getSymbol(iso) {
      var b = document.body;

      var icon = b.getAttribute("data-crcicon");
      if (icon && icon.trim()) return icon.trim();

      try {
        var parts = new Intl.NumberFormat(undefined, { style: "currency", currency: iso }).formatToParts(0);
        for (var i = 0; i < parts.length; i++) {
          if (parts[i].type === "currency") return parts[i].value;
        }
      } catch (e) {}
      return "";
    }

    function parseFreeLimit() {
      var raw = document.body.getAttribute("data-freelimit");
      if (!raw) return null;

      var s = String(raw).trim();
      if (!s) return null;

      s = s.replace(/[^\d.,\s]/g, "");
      s = s.replace(/\s+/g, "");
      if (!s) return null;

      var hasComma = s.indexOf(",") !== -1;
      var hasDot = s.indexOf(".") !== -1;

      if (hasComma && hasDot) {
        var lastComma = s.lastIndexOf(",");
        var lastDot = s.lastIndexOf(".");
        var decSep = lastComma > lastDot ? "," : ".";
        var thouSep = decSep === "," ? "." : ",";

        s = s.split(thouSep).join("");
        if (decSep === ",") s = s.replace(",", ".");
        var n1 = parseFloat(s);
        return isFinite(n1) ? n1 : null;
      }

      if (hasComma && !hasDot) {
        var partsC = s.split(",");
        var lastC = partsC[partsC.length - 1];
        if (lastC.length > 0 && lastC.length <= 2) {
          s = partsC.slice(0, -1).join("") + "." + lastC;
        } else {
          s = partsC.join("");
        }
        var n2 = parseFloat(s);
        return isFinite(n2) ? n2 : null;
      }

      if (hasDot && !hasComma) {
        var partsD = s.split(".");
        var lastD = partsD[partsD.length - 1];
        if (lastD.length > 0 && lastD.length <= 2) {
          s = partsD.slice(0, -1).join("") + "." + lastD;
        } else {
          s = partsD.join("");
        }
        var n3 = parseFloat(s);
        return isFinite(n3) ? n3 : null;
      }

      var n4 = parseFloat(s);
      return isFinite(n4) ? n4 : null;
    }

    function formatLimit(n) {
      try {
        var hasDecimals = Math.abs(n - Math.round(n)) > 1e-9;
        return new Intl.NumberFormat(undefined, {
          style: "decimal",
          minimumFractionDigits: hasDecimals ? 2 : 0,
          maximumFractionDigits: hasDecimals ? 2 : 0
        }).format(n);
      } catch (e) {
        return String(n);
      }
    }

    function paint(scope) {
      var root = scope && scope.querySelectorAll ? scope : document;

      var cc = getCountry();
      var isInternational = !cc || !SUPPORTED_COUNTRIES[cc];

      var iso = isInternational ? US_DEFAULT_ISO : getIso();
      var sym = getSymbol(iso);

      var limit = isInternational ? US_DEFAULT_LIMIT : parseFreeLimit();

      if (limit == null || !sym) return;

      var nodes = root.querySelectorAll(".js-free-shipping-text");
      if (!nodes || !nodes.length) return;

      var formatted = formatLimit(limit);

      for (var i = 0; i < nodes.length; i++) {
        var el = nodes[i];
        var lead = el.getAttribute("data-fstext") || "Free shipping above";
        var next = lead + " " + sym + formatted;
        if (el.textContent !== next) el.textContent = next;
      }
    }

    var raf = 0;
    function schedule(target) {
      if (raf) cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () {
        raf = 0;
        paint(target || document);
      });
    }

    document.addEventListener("DOMContentLoaded", function () { schedule(document); });
    document.addEventListener("shopify:section:load", function (e) { schedule(e.target || document); });
    document.addEventListener("cart:sections:replaced", function () { schedule(document); });

    var mo = new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var m = muts[i];

        if (m.type === "attributes" && m.target === document.body) {
          if (
            m.attributeName === "data-crcicon" ||
            m.attributeName === "data-crciso" ||
            m.attributeName === "data-currency" ||
            m.attributeName === "data-freelimit" ||
            m.attributeName === "data-country" ||
            m.attributeName === "data-crc-country"
          ) {
            schedule(document);
            return;
          }
        }

        if (m.type === "childList" && m.addedNodes && m.addedNodes.length) {
          for (var j = 0; j < m.addedNodes.length; j++) {
            var n = m.addedNodes[j];
            if (!n || n.nodeType !== 1) continue;
            if (
              (n.matches && n.matches(".js-free-shipping-text, cart-drawer, .cart-drawer")) ||
              (n.querySelector && n.querySelector(".js-free-shipping-text"))
            ) {
              schedule(document);
              return;
            }
          }
        }
      }
    });

    mo.observe(document.documentElement, { childList: true, subtree: true });
    mo.observe(document.body, {
      attributes: true,
      attributeFilter: ["data-crcicon", "data-crciso", "data-currency", "data-freelimit", "data-country", "data-crc-country"]
    });

    setInterval(function () { schedule(document); }, 250);
    setTimeout(function () { schedule(document); }, 50);
    setTimeout(function () { schedule(document); }, 500);
    setTimeout(function () { schedule(document); }, 1200);
  })();

  customElements.define('cart-drawer-info-slider', CartDrawerInfoSlider);
}
